module.exports = __webpack_public_path__ + "img/icon-download.f066d743.svg";